import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from 'flowbite-react';
import { useStaffSession } from '../../context/StaffSessionContext';

function WaiterAccessGuard() {
  const { token, loading } = useStaffSession();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-40 items-center justify-center gap-2 text-sm text-slate-600">
        <Spinner size="sm" /> <span>Restoring staff session…</span>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/staff/portal" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

export default WaiterAccessGuard;
